<template>
    <form action="">
        <div class="modal-card">
            <header class="modal-card-head">
                <p class="modal-card-title">Contact by {{ LoggedInProfile.company }}</p>
            </header>
            <section class="modal-card-body">
                <b-field label="Request type">
                    <b-select placeholder="Select option" v-model="supportRequest.requestType" required>
                        <option value="Support request">Support request</option>
                        <option value="General question">General question</option>
                    </b-select>
                </b-field>
                <b-field label="Message">
                    <b-input placeholder="Type your message here" v-model="supportRequest.requestMessage" maxlength="800" type="textarea"></b-input>
                </b-field>
            </section>
            <footer class="modal-card-foot">
                <b-button label="Send" @click="sendMessage" type="is-primary" :loading="loadingState" />
                <b-button label="Close" @click="$parent.close()" />
            </footer>
        </div>
    </form>
</template>
<script>
import * as firebase from "../firebase"
import { SnackbarProgrammatic as screenMessage } from 'buefy'

export default {
    computed: {
        LoggedInProfile() {
            return this.$store.state.userProfile;
        }
    }, 
    data: function() {
        return {
            supportRequest: {
                requestType: null,
                requestMessage: "",
            },
            loadingState: false
        }
    },
    methods: {
        sendMessage: function() {
            var createdDate = new Date().toLocaleString();
            if (this.supportRequest.requestType != null && this.supportRequest.requestMessage.length > 1) {
                this.loadingState = true; 
                firebase.supportRequestCollection.add({
                    type: this.supportRequest.requestType,
                    message: this.supportRequest.requestMessage,
                    sender: this.LoggedInProfile,
                    created: createdDate
                }).then((docRef) => {
                    console.log("Document was added with ID: ", docRef.id);
                    this.loadingState = false;
                    this.$parent.close();
                    this.supportRequest = {};
                    screenMessage.open({type: "is-success", message: "Success! Message from " + this.LoggedInProfile.company  + " sent successfully."});
                }).catch((error) => {
                    console.log("Error adding document: ", error);
                    this.loadingState = false;
                    this.$parent.close()
                    screenMessage.open({type: "is-danger", message: error.message});
                });
            } else {
                screenMessage.open({type: "is-danger", message: "Error: Make sure you select the request type before sending your message."});
            }
        }
    }
}

</script>